<div class="footer-row">
    <div class="footer-content">
        &copy; Blue Sheild of California 1999-{{currentYear}}. All rights reserved.
    </div>
</div>